<template>
  <div>
    <SkeletonLoader
      width="250px"
      height="32px"
      class="mb-6"
    />
    <SkeletonLoader
      class="gap-6 lg:flex hidden justify-center"
      :number-of-items="3"
      width="30%"
      height="510px"
    />
    <SkeletonLoader
      class="lg:hidden block"
      width="100%"
      height="510px"
    />
  </div>
</template>
<script lang="ts">

export default defineComponent({
  name: 'ProductSliderContainerSkeleton',
});

</script>
